import React from "react";
import ReactDOM from "react-dom";

// styles | global
import "./styles/global.scss";

// main component
import App from "./App";

// reports
import reportWebVitals from "./reportWebVitals";

// ROUTER
import { BrowserRouter as Router } from "react-router-dom";

// REACT REDUX
import { Provider } from "react-redux";

// REDUX STORE
import appStore from "redux/store/store";

// styles components | theme
import { ThemeProvider } from "styled-components";
import globalTheme1 from "styles/styledThemes/theme1/globalTheme";

ReactDOM.render(
    <React.StrictMode>
        <Provider store={appStore}>
            <ThemeProvider theme={globalTheme1}>
                <Router>
                    <App />
                </Router>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
